import React from "react";
import { Form, Input, Button } from 'antd';
import { useGraphicStandMutation } from '../../hooks';
import { Localize, EntityRemoveButton } from 'components/service';
import GraphicStandSelect from '../fields/graphic-stand-select-form-item';
import { GRAPHIC_STAND_STATUS } from '../../graphic-stand-const';


const GraphicStandEditForm = ({ graphicStand, graphicList }) => {

    const [ form ] = Form.useForm();

    const {
        create,
        update,
        loading: loadingMutationGraphicStandCreateUpdate
    } = useGraphicStandMutation.createUpdate({
        graphicStandId: graphicStand?.id,
        graphicListId: graphicList?.id
    });

    const {
        _setMutationGraphicStandDelete,
        loadingMutationGraphicStandDelete
    } = useGraphicStandMutation.delete({
        graphicStand,
        graphicListId: graphicList?.id
    });

    return (
        <Form
            key="edit-graphic-stand-form"
            layout="vertical"
            form={ form }
            className="model-form graphic-stand-form"
            onFinish={ (values) => {
                const mutationFunction = graphicStand?.id ? update : create;

                mutationFunction({
                    variables: {
                        input: {
                            id: graphicStand?.id ? +graphicStand.id : undefined,
                            ...values,
                            graphic_list_id: graphicList?.id,
                            status: graphicStand?.id ? graphicStand.status : GRAPHIC_STAND_STATUS.OPEN,
                            shelf_number: undefined,
                        }
                    }
                });
            } }>

            <div className="row-grid grid-gap-10 row-gap-0 col-md-2">
                <GraphicStandSelect
                    disabled={ graphicStand?.id }
                    form={ form }
                    initialValue={ graphicStand }
                />

                <Form.Item
                    name="shelf_number"
                    label={ <Localize>FORMS.Input_Label_GraphicStandShelfNumber</Localize> }
                    initialValue={ graphicStand?.relStand?.shelf_number }
                >
                    <Input disabled={ true } name="shelf_number" />
                </Form.Item>

                <Form.Item
                    hidden={ true }
                    name="stand_id"
                    initialValue={ graphicStand?.relStand?.id }
                >
                    <Input disabled={ true } name="stand_id" />
                </Form.Item>
            </div>

            <div className="row-grid grid-gap-10 row-gap-0 col-md-2">
                <Form.Item
                    name="hall_name"
                    label={ <Localize>FORMS.Input_Label_Hall</Localize> }
                    initialValue={ graphicStand?.hall_name }
                >
                    <Input name="hall_name" />
                </Form.Item>

                <Form.Item
                    name="corridor"
                    label={ <Localize>FORMS.Input_Label_Corridor</Localize> }
                    initialValue={ graphicStand?.corridor }
                >
                    <Input name="corridor" />
                </Form.Item>

            </div>

            <div className="row-grid grid-gap-10 row-gap-0 col-md-2">
                <Form.Item
                    name="block"
                    label={ <Localize>FORMS.Input_Label_Block</Localize> }
                    initialValue={ graphicStand?.block }
                >
                    <Input name="block" />
                </Form.Item>


                <Form.Item
                    name="stand_number"
                    label={ <Localize>FORMS.Input_Label_StandNumber</Localize> }
                    initialValue={ graphicStand?.stand_number }
                    rules={ [
                        { required: true, message: <Localize>FORM_RULES.Required_StandNumber</Localize> }
                    ] }
                >
                    <Input name="stand_number" />
                </Form.Item>
            </div>

            <div className="form-btn-holder">
                { graphicStand?.id &&
                    <EntityRemoveButton
                        modalButton={
                            <Button className="ant-btn-secondary">
                                <Localize>STAND.Button_Text_Delete</Localize>
                            </Button>
                        }

                        nameEntity={ Localize({ children: "ENTITY.Modal_Title_Stand" }).props.children }
                        dataNameEntity={ `${ graphicStand?.exhibitor } - ${ graphicStand?.stand_number }` }
                        loading={ loadingMutationGraphicStandDelete }
                        deleteMutation={ () => _setMutationGraphicStandDelete({ variables: { id: graphicStand.id } }) }
                    /> }

                <Button
                    className="btn-right"
                    type="primary"
                    htmlType="submit"
                    loading={ loadingMutationGraphicStandCreateUpdate }
                >
                    { graphicStand?.id ? <Localize>GLOBAL.Button_Text_SaveChanges</Localize> : <Localize>GRAPHIC_STAND.Button_Text_Create</Localize> }
                </Button>
            </div>
        </Form>
    );
};

export default GraphicStandEditForm;